import { createContext, useContext } from 'react'

export interface NavigateOptions {
    label?: string
    pop?: boolean
}

export interface TransitionState {
    /** True once the curtain starts lifting, so page content may play its entrance. */
    ready: boolean
    /** Seconds a page should wait before its entrance timeline plays. */
    enterDelay: number
    navigating: boolean
    navigate: (href: string, options?: NavigateOptions) => void
}

export const TransitionContext = createContext<TransitionState>({
    ready: true,
    enterDelay: 0,
    navigating: false,
    navigate: () => undefined
})

export const usePageTransition = (): TransitionState => useContext(TransitionContext)
